module.exports = __webpack_public_path__ + "img/1.4eaa6d7c.png";